import { Request } from 'commons/utils/request'
import { CTREditRequest } from '~bank-bsa-reporting/types'

export const remove = (opts: { id: number }) => Request.delete(Request.urls.bank.bsaCtr, opts)

export const save = (item: CTREditRequest) => {
  const saveFunc = item.id ? Request.put : Request.post
  return saveFunc(Request.urls.bank.bsaCtr, item)
}

export const validate = (opts: CTREditRequest) => Request.post(Request.urls.bank.bsaCtrValidate, opts)

export const generateXML = (opts: { ctr_ids: number[] }) => Request.post(Request.urls.bank.bsaCtrFormBatch, opts)

export const generateCTRs = (opts: { date: string }) => Request.post(Request.urls.bank.bsaCtrForm, opts)

export const approveCTR = (opts: { id: number }) => Request.patch(Request.urls.bank.bsaCtrApprove, opts)

export const cancelCTR = (opts: { id: number }) => Request.patch(Request.urls.bank.bsaCtrCancel, opts)
